import React from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../sections/Footer/Footer';
import SEO from '../../components/SEO/SEO';
import { Link } from 'react-router-dom';
import './DatenschutzSocialMedia.scss';

const DatenschutzSocialMedia = () => {
    return (
        <>
            <SEO
                title="Datenschutz Social Media | Zahnarztpraxis Roman Boretskyi"
                description="Datenschutzhinweise zur Nutzung unserer Social-Media-Kanäle."
                path="/datenschutz-social-media"
                noindex
            />
            <Navbar />
            <section className='section-bg section-common datenschutz-social-section pt-100 pb-70'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-10 mx-auto">
                            <h1>Datenschutzerklärung für Social Media</h1>
                            
                            <h2>1. Allgemeine Hinweise</h2>
                            <p>
                                Diese Datenschutzerklärung informiert Sie über die Verarbeitung 
                                personenbezogener Daten im Zusammenhang mit unseren Social-Media-Auftritten. 
                                Personenbezogene Daten sind alle Daten, mit denen Sie persönlich 
                                identifiziert werden können.
                            </p>
                            <p>
                                Wir betreiben derzeit ein Profil auf folgender Social-Media-Plattform: 
                                Instagram. Wir nutzen dieses Profil, um mit Ihnen zu kommunizieren, 
                                Sie über unsere Leistungen zu informieren und Ihnen aktuelle Informationen 
                                zu präsentieren.
                            </p>

                            <h2>2. Verantwortliche Stelle</h2>
                            <p>
                                Die verantwortliche Stelle für die Datenverarbeitung auf unseren 
                                Social-Media-Profilen ist:
                            </p>
                            <p>
                                <strong>Zahnarztpraxis Roman Boretskyi</strong><br />
                                Roman Boretskyi<br />
                                Kornstraße 53a<br />
                                47918 Tönisvorst<br />
                                Deutschland
                            </p>
                            <p>
                                Telefon: 02151803208<br />
                                E-Mail: anmeldung@zahnarzt-st-toenis.de
                            </p>
                            <p>
                                <strong>Gemeinsame Verantwortlichkeit mit Meta (Art. 26 DSGVO):</strong><br />
                                Wir betreiben unsere Instagram-Seite als gemeinsam Verantwortliche mit 
                                Meta Platforms Ireland Limited gemäß Art. 26 DSGVO. Die gemeinsame 
                                Verantwortlichkeit ergibt sich aus der „Page Insights Controller Addendum"-Vereinbarung 
                                von Meta („Seiten-Insights-Ergänzung bezüglich des Verantwortlichen"), abrufbar unter 
                                <a href="https://www.facebook.com/legal/terms/page_controller_addendum" target="_blank" rel="noopener noreferrer">
                                    https://www.facebook.com/legal/terms/page_controller_addendum
                                </a>.
                            </p>
                            <p>
                                In dieser Vereinbarung ist insbesondere geregelt, dass Meta die primäre 
                                Verantwortung für die Verarbeitung von Insights-Daten sowie die Erfüllung 
                                der Betroffenenrechte übernimmt. Ungeachtet dessen können Sie Ihre Rechte 
                                sowohl gegenüber Meta als auch gegenüber uns geltend machen.
                            </p>

                            <h2>3. Instagram</h2>
                            
                            <h3>3.1 Verantwortlicher</h3>
                            <p>
                                Wir betreiben ein Profil auf Instagram. Anbieter ist die 
                                <strong> Meta Platforms Ireland Limited</strong>, 4 Grand Canal Square, 
                                Grand Canal Harbour, Dublin 2, Irland.
                            </p>
                            <p>
                                <strong>Kontaktdaten des Datenschutzbeauftragten:</strong><br />
                                <a href="https://www.facebook.com/help/contact/540977946302970" target="_blank" rel="noopener noreferrer">
                                    https://www.facebook.com/help/contact/540977946302970
                                </a>
                            </p>
                            <p>
                                <strong>Unsere Instagram-Seite:</strong><br />
                                <a href="https://www.instagram.com/zap_boretskyi" target="_blank" rel="noopener noreferrer">
                                    https://www.instagram.com/zap_boretskyi
                                </a>
                            </p>

                            <h3>3.2 Datenverarbeitung durch Instagram</h3>
                            <p>
                                Wenn Sie unsere Instagram-Seite besuchen oder mit unseren Beiträgen 
                                interagieren, erhebt Instagram automatisch Daten über Sie. Dies umfasst:
                            </p>
                            <ul>
                                <li>Ihre IP-Adresse</li>
                                <li>Geräteinformationen (Gerätetyp, Betriebssystem)</li>
                                <li>Standortdaten (sofern freigegeben)</li>
                                <li>Cookies und ähnliche Technologien</li>
                                <li>Interaktionsdaten (Likes, Kommentare, Shares, Aufrufe)</li>
                                <li>Profilinformationen (soweit öffentlich oder mit uns geteilt)</li>
                            </ul>
                            <p>
                                <strong>Rechtsgrundlage:</strong> Die Datenverarbeitung durch Instagram 
                                erfolgt eigenverantwortlich durch Meta Platforms Ireland Limited auf Grundlage 
                                der in der Datenschutzrichtlinie von Meta beschriebenen Rechtsgrundlagen. 
                                Details hierzu (einschließlich der jeweils einschlägigen Rechtsgrundlagen) 
                                finden Sie in der Datenschutzrichtlinie von Meta für Instagram:
                            </p>
                            <p>
                                <a href="https://help.instagram.com/519522125107875" target="_blank" rel="noopener noreferrer">
                                    https://help.instagram.com/519522125107875
                                </a>
                            </p>
                            <p>
                                <strong>Zweck:</strong> Instagram nutzt die Daten zur Bereitstellung 
                                und Verbesserung seiner Dienste, zur Personalisierung von Inhalten, 
                                zur Werbung und zur Analyse des Nutzerverhaltens.
                            </p>

                            <h3>3.3 Datenverarbeitung durch uns</h3>
                            <p>
                                Wir verarbeiten folgende Daten im Rahmen unserer Instagram-Präsenz:
                            </p>
                            <ul>
                                <li>
                                    <strong>Kommentare und Nachrichten:</strong> Wenn Sie uns Kommentare 
                                    schreiben oder Direktnachrichten senden, speichern wir diese zur 
                                    Beantwortung Ihrer Anfragen. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f 
                                    DSGVO (berechtigtes Interesse an der Kommunikation mit unseren 
                                    Patienten und Interessenten).
                                </li>
                                <li>
                                    <strong>Statistiken:</strong> Instagram stellt uns über „Instagram Insights" 
                                    aggregierte und statistisch aufbereitete Auswertungen zur Verfügung 
                                    (z. B. Reichweiten-, Interaktions- und Demografie-Daten). Diese 
                                    Auswertungen liegen uns nur in zusammengefasster Form vor, sodass wir 
                                    daraus in der Regel keine direkten Rückschlüsse auf einzelne Personen 
                                    ziehen können.
                                </li>
                            </ul>

                            <h3>3.4 Ihre Rechte</h3>
                            <p>
                                Sie haben folgende Rechte bezüglich Ihrer personenbezogenen Daten:
                            </p>
                            <ul>
                                <li>
                                    <strong>Auskunftsrecht (Art. 15 DSGVO):</strong> Sie können 
                                    Auskunft über die von uns oder Instagram verarbeiteten Daten 
                                    verlangen.
                                </li>
                                <li>
                                    <strong>Berichtigungsrecht (Art. 16 DSGVO):</strong> Sie können 
                                    die Berichtigung unrichtiger Daten verlangen.
                                </li>
                                <li>
                                    <strong>Löschungsrecht (Art. 17 DSGVO):</strong> Sie können die 
                                    Löschung Ihrer Daten verlangen, sofern keine gesetzlichen 
                                    Aufbewahrungspflichten entgegenstehen.
                                </li>
                                <li>
                                    <strong>Einschränkung der Verarbeitung (Art. 18 DSGVO):</strong> 
                                    Sie können die Einschränkung der Verarbeitung Ihrer Daten verlangen.
                                </li>
                                <li>
                                    <strong>Widerspruchsrecht (Art. 21 DSGVO):</strong> Sie können 
                                    der Verarbeitung Ihrer Daten widersprechen, insbesondere wenn 
                                    diese zu Werbezwecken erfolgt.
                                </li>
                                <li>
                                    <strong>Datenübertragbarkeit (Art. 20 DSGVO):</strong> Sie können 
                                    Ihre Daten in einem strukturierten, gängigen und maschinenlesbaren 
                                    Format erhalten.
                                </li>
                            </ul>
                            <p>
                                <strong>Wichtig:</strong> Da Instagram als Plattformbetreiber ebenfalls 
                                für die Datenverarbeitung verantwortlich ist, können Sie Ihre Rechte 
                                auch direkt gegenüber Instagram geltend machen. Informationen hierzu 
                                finden Sie in der Datenschutzerklärung von Instagram:
                            </p>
                            <p>
                                <a href="https://help.instagram.com/519522125107875" target="_blank" rel="noopener noreferrer">
                                    https://help.instagram.com/519522125107875
                                </a>
                            </p>

                            <h3>3.5 Speicherdauer</h3>
                            <p>
                                <strong>Kommentare und Nachrichten:</strong> Wir speichern Ihre 
                                Kommentare und Nachrichten, bis Sie diese löschen oder wir sie 
                                löschen, es sei denn, es bestehen gesetzliche Aufbewahrungspflichten. 
                                Wir überprüfen unsere auf Instagram geführten Direktnachrichten regelmäßig 
                                und löschen diese, sobald sie für die Kommunikation mit Ihnen nicht mehr 
                                erforderlich sind und keine gesetzlichen Aufbewahrungspflichten entgegenstehen. 
                                Spätestens mit Abschluss des jeweiligen Vorgangs werden Ihre Direktnachrichten 
                                gelöscht.
                            </p>
                            <p>
                                <strong>Daten bei Instagram:</strong> Die Speicherdauer der Daten 
                                bei Instagram richtet sich nach den Datenschutzbestimmungen von 
                                Instagram. Wir haben keinen direkten Einfluss auf die Speicherdauer 
                                bei Instagram.
                            </p>

                            <h3>3.6 Datenschutzeinstellungen</h3>
                            <p>
                                Sie können Ihre Datenschutzeinstellungen bei Instagram selbst 
                                verwalten:
                            </p>
                            <ul>
                                <li>In den Instagram-Einstellungen können Sie festlegen, welche 
                                    Informationen öffentlich sichtbar sind.</li>
                                <li>Sie können die Verwendung Ihrer Daten für Werbezwecke 
                                    einschränken.</li>
                                <li>Sie können Cookies und Tracking-Technologien in Ihrem Browser 
                                    blockieren.</li>
                            </ul>
                            <p>
                                Weitere Informationen finden Sie in den Datenschutzeinstellungen 
                                Ihres Instagram-Kontos.
                            </p>

                            <h3>3.7 Datenübertragung in Drittländer</h3>
                            <p>
                                Instagram/Meta kann personenbezogene Daten auch in die USA und andere 
                                Drittländer übertragen. Die jeweilige Rechtsgrundlage und die eingesetzten 
                                Garantien (z. B. EU-US Data Privacy Framework, Standardvertragsklauseln) 
                                ergeben sich aus den Datenschutzbestimmungen von Meta.
                            </p>
                            <p>
                                <strong>Hinweis:</strong> Wir weisen darauf hin, dass bei Datenübertragungen 
                                in Drittländer außerhalb der EU/EWR unter Umständen ein niedrigeres 
                                Datenschutzniveau bestehen kann (z. B. weiterreichende Zugriffsbefugnisse 
                                von Sicherheitsbehörden). Wenn Sie dies nicht wünschen, sollten Sie auf die 
                                Nutzung von Instagram verzichten oder Ihre Datenschutzeinstellungen 
                                entsprechend anpassen.
                            </p>

                            <h2>4. Allgemeine Bestimmungen</h2>
                            
                            <h3>4.1 Beschwerderecht</h3>
                            <p>
                                Sie haben das Recht, eine Beschwerde bei der zuständigen 
                                Aufsichtsbehörde einzulegen, wenn Sie der Ansicht sind, dass die 
                                Verarbeitung Ihrer personenbezogenen Daten gegen die DSGVO verstößt.
                            </p>
                            <p>
                                <strong>Zuständige Aufsichtsbehörde für Nordrhein-Westfalen:</strong><br />
                                <strong>Landesbeauftragte für Datenschutz und Informationsfreiheit 
                                Nordrhein-Westfalen</strong><br />
                                Postfach 20 04 44<br />
                                40102 Düsseldorf<br />
                                Telefon: 0211 38424-0<br />
                                E-Mail: poststelle@ldi.nrw.de<br />
                                Website: <a href="https://www.ldi.nrw.de/" target="_blank" rel="noopener noreferrer">https://www.ldi.nrw.de/</a>
                            </p>

                            <h3>4.2 Änderungen dieser Datenschutzerklärung</h3>
                            <p>
                                Wir behalten uns vor, diese Datenschutzerklärung anzupassen, um sie 
                                an geänderte Rechtslagen oder bei Änderungen unserer Social-Media-Aktivitäten 
                                anzupassen. Die jeweils aktuelle Version finden Sie auf dieser Seite.
                            </p>

                            <h3>4.3 Kontakt</h3>
                            <p>
                                Bei Fragen zur Datenverarbeitung in unseren Social-Media-Profilen 
                                können Sie sich jederzeit an uns wenden:
                            </p>
                            <p>
                                Zahnarztpraxis Roman Boretskyi<br />
                                Roman Boretskyi<br />
                                Kornstraße 53a<br />
                                47918 Tönisvorst<br />
                                Deutschland<br />
                                Telefon: 02151803208<br />
                                E-Mail: anmeldung@zahnarzt-st-toenis.de
                            </p>
                            
                            <div className="datenschutz-footer">
                                <hr />
                                <p>
                                    <strong>Stand:</strong> {new Date().toLocaleDateString('de-DE', { year: 'numeric', month: 'long', day: 'numeric' })}
                                </p>
                                <p>
                                    Diese Datenschutzerklärung wurde unter Berücksichtigung der Anforderungen 
                                    der DSGVO (Datenschutz-Grundverordnung) und des DDG (Digital-Dienste-Gesetz) 
                                    sowie der Empfehlungen der Zahnärztekammer Nordrhein erstellt.
                                </p>
                                <p>
                                    <strong>Weitere Informationen:</strong><br />
                                    <Link to="/datenschutz">Allgemeine Datenschutzerklärung</Link>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
};

export default DatenschutzSocialMedia;
